var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-group",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          if ($event.target !== $event.currentTarget) return null
        },
      },
    },
    [
      _vm.label
        ? _c("label", { attrs: { for: _vm.name } }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _vm.required
        ? _c("span", { staticClass: "text-danger" }, [_vm._v(" *")])
        : _vm._e(),
      _vm._v(" "),
      _c("multiselect", {
        attrs: {
          id: _vm.name,
          name: _vm.name,
          options: _vm.options || [],
          multiple: _vm.multiple,
          "track-by": _vm.valueField,
          label: _vm.labelField,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
        },
        on: { input: _vm.onChange },
        model: {
          value: _vm.vModel,
          callback: function ($$v) {
            _vm.vModel = $$v
          },
          expression: "vModel",
        },
      }),
      _vm._v(" "),
      _vm.errors && _vm.errors[_vm.error_name || _vm.name]
        ? _c("small", {
            staticClass: "form-text text-danger",
            domProps: {
              textContent: _vm._s(_vm.errors[_vm.error_name || _vm.name][0]),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }